import { Injectable, signal } from '@angular/core';

export interface ToastMessage {
  id: number;
  title: string;
  body?: string;
  variant?: 'success' | 'danger' | 'info';
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private counter = 0;
  readonly toasts = signal<ToastMessage[]>([]);

  show(title: string, body = '', variant: ToastMessage['variant'] = 'info'): void {
    const item = { id: ++this.counter, title, body, variant };
    this.toasts.update((current) => [...current, item]);
    setTimeout(() => this.dismiss(item.id), 3000);
  }

  dismiss(id: number): void {
    this.toasts.update((current) => current.filter((toast) => toast.id !== id));
  }
}
